import { newClient } from './axios-client-new';
import AES from "@/tools/AES.js";
import {isBondo} from "../util";
import {EMAIL_LOGIN_PARAM_MAP, mapFieldsReverse, PHONE_LOGIN_PARAM_MAP} from "../util/FieldMapUtil";
import {newClient as newClientOld, redirect_url} from "./axios-client-old";
const isInBondo = isBondo()
// 获取用户区号信息
export const getCountryMsgAjax = function(phoneCountry) {
  const url = isInBondo ? '/bondo/base/country/data' : '/api/h5/foundation/country/detail'
  const model = isInBondo ? { code: phoneCountry } : { "phoneCountry":phoneCountry }
  return newClient().post(url,model)
}
// 获取区号列表
export const getCountryCodeListAjax = function(phoneLang) {
  const url = isInBondo ? '/bondo/base/country/list' : '/api/h5/foundation/country/multilingual/list'
  if(isInBondo) {
    return newClientOld().post(url)
  } else {
    return newClient().post(url,{
      "sysLanguage":phoneLang,
      "phoneLanguage":phoneLang,
    })
  }
}

/**
 * bondo手机登录校验
 * @param json
 */
export const bondoPhoneLoginCheck = function(model) {
  const obj = {
    dialingCode: model.dialingCode,
    mobile: model.mobile
  }
  return newClient().post('/bondo/h5/user/access/mobile/inspect', obj)
}

/**
 * bondo邮箱登录校验
 * @param json
 */
export const bondoEmailLoginCheck = function(model) {
  const obj = { email: model.email }
  return newClient().post('/bondo/h5/user/access/email/inspect', obj)
}

// 登录
export const loginAjax = function(json) {
  let jsonData = {
    ...json,
    timestamp:new Date().getTime(),
  };
  // type=google&eyJhbGciOiJSUzI1NiIsImtpZCI6IjFiYjc3NGJkODcyOWVhMzhlOWMyZmUwYzY0ZDJjYTk0OGJmNjZmMGYiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJhenAiOiI2MDg1ODU5MTk4Mjgtamh2ajUycmJkdmdzbWVvcXRqbjlsZGU1amg2dWRscXUuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiI2MDg1ODU5MTk4Mjgtamh2ajUycmJkdmdzbWVvcXRqbjlsZGU1amg2dWRscXUuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMDE1MDU3NTExNTMzMjMwNjc0MzQiLCJlbWFpbCI6ImppYWp3OTUyN0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmJmIjoxNzUwMzE5MDQzLCJuYW1lIjoiSlcgSmlhIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FDZzhvY0lJal95dzQwV20wTkJJdThUVlF6U21sZ2NMMEhtbGZqSHlaNDBzSmxnVy1pTUpTdz1zOTYtYyIsImdpdmVuX25hbWUiOiJKVyIsImZhbWlseV9uYW1lIjoiSmlhIiwiaWF0IjoxNzUwMzE5MzQzLCJleHAiOjE3NTAzMjI5NDMsImp0aSI6ImZlMWQ4Y2MwMzEyMjA0ODQ0YWUzYzJmMTkwOTIzY2UzMGEzODk4YTcifQ.H7mnkvGiN4kmTif3ChrZSghBYUpWpHaqxcopJCAjkJ6STqDIRHRKWEUebEnuddqSqwkMS9smsNCPRs0riKKletmkaARXM2cgvXbY80mmBHy-XC0DLxB4y6Jq-NmUuFYjMH1kFLAYcHSTBeKgrpJk7v4nKivpRAXPtxfRd1oZfMOf4eDCwFRlWjGNmckINaVE1nVQ-cPwrfXC7Q9ZLwGz4cPW9gIoX8TQQgz_1s0jjRdEeSVnIVD5vBDEnYvrYg_wAbzWmbZzlLQ5y9zA9ecj4vrt8EjW5-Ugo2PQR1i0yO0tSkcdOUHlaqfCE5cGxlbkqIBLOiP7AgBNvFLDfbDLog
  console.log('11111111122222222222',jsonData);
  // bondo字段映射

  if(isInBondo) {
    // 3: 手机登录
    if(jsonData.type === 3) {
      const model = mapFieldsReverse(jsonData, PHONE_LOGIN_PARAM_MAP)
      return newClient().post('/bondo/h5/user/access/mobile/login', model)
    }
    // 2: 邮箱登录
    if(jsonData.type === 2) {
      const model = mapFieldsReverse(jsonData, EMAIL_LOGIN_PARAM_MAP)
      return newClient().post('/bondo/h5/user/access/email/login', model)
    }
  } else {
    let str = JSON.stringify(jsonData);
    console.log("login:", str)
    const encrypts = AES.encrypt(str);
    console.log(encrypts);
    return newClient().post('/api/h5/user/auth/login', { sign: encrypts })
  }
}

/**
 * bondo-Token登录
 * @param apiToken
 */
export function bondoTokenLogin(apiToken, sysToken) {
  return newClient().post('/bondo/h5/user/access/token/login', { apiTk: apiToken, sysTk: sysToken })
}

// 生成二维码
export const getQrcodeInfoAjax = function(){
  let time = new Date().getTime();
  let signText = AES.MD5jiami(time+'guochao@8859-1#$');
  return newClient().post('/api/h5/user/auth/qrcode/generate',{
    "key":signText.toUpperCase(),
    "timestamp":time,
  })
}
// 检查qrcode是否有效
export const checkQrcodeAjax = function({keyCode , platform}){
  let time = new Date().getTime();
  let signText = AES.MD5jiami(time+'guochao@8859-1#$');
  return newClient().post('/api/h5/user/auth/qrcode/pull',{
    "key":signText.toUpperCase(),
    "timestamp":time,
    "keyCode":keyCode,
    "platform":platform
  })
}

// 判断是否是币商
export const getIsSellerAjax = function(){
  return newClient().post('/api/h5/token/trade/account/traderState')
}
/**
 * 获取dukpay美元和本地货币的转换汇率
 * @param params 参数对象或countryId
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getDukpayRatio = function(params){
  // 兼容数字（旧调用方式）和对象（新调用方式）
  const countryId = typeof params === 'object' ? params.countryId : params;

  // 根据环境选择接口URL、参数和请求客户端
  const url = isInBondo ? '/bondo/auth/trade/dukPay/recharge/getRate' : '/api/h5/trade/dukPay/payIn/getRate';
  const requestParams = isInBondo ? {cid: countryId } : { countryId: countryId };
  return newClient().post(url, requestParams);
}
/**
 * 获取当前ip所在的国家 coding
 */
export const getCountryByIp = function(){
  const url = isInBondo ? '/bondo/home/user/pay/address' : '/web/h5/getCountryByIp'
  return newClient().get(url);
}

export function toThirdPage(url) {
  return redirect_url(url)
}



// WEBPACK FOOTER //
// ./src/api/index.js